import { gql } from '@apollo/client';

export default gql`
    {
        UsersNumber
    }
`;